<template>
  <div class="date-picker--container">
    <input
      :style="{display: displayInputComputed}"
      v-bind:disabled="show"
      @focusin="showCalendar"
      v-mask="'##.##.####'"
      type="text"
      v-model="model"
      readonly
      class="cursor-pointer"
    />
    <div v-if="show" @click="hideCalendar" class="date-picker--back"></div>
    <div v-show="show" class="date-picker--calendar">
      <div class="date-picker--actions">
        <div class="left cursor-pointer" @click="prevMonth">
          <f-awesome icon="arrow-left"></f-awesome>
        </div>
        <div class="month">{{ nowMonthName }}, {{ nowYear }}</div>
        <div class="right cursor-pointer" @click="nextMonth">
          <f-awesome icon="arrow-right"></f-awesome>
        </div>
      </div>
      <div class="date-picker--calendar-container no-select">
        <div class="date-picker--calendar-overflow">
          <div
            class="date-picker--calendar-body date-picker--calendar-weeksname"
          >
            <div>Пнд</div>
            <div>Вт</div>
            <div>Ср</div>
            <div>Чтв</div>
            <div>Птн</div>
            <div class="weekend">Сб</div>
            <div class="weekend">Вскр</div>
          </div>
          <div
            v-for="(week, key) in calendar"
            :key="key"
            class="date-picker--calendar-body date-picker--calendar-week"
          >
            <div
              @click="clickSelectDay(day)"
              class="item"
              v-bind:class="{ selected: day.selected === true }"
              v-for="(day, index) in week"
              :key="index"
            >
              <div class="date" v-if="day.day !== 0">
                <div
                  v-bind:class="{
                    today: day.today === true,
                    active: day.active === true
                  }"
                >
                  {{ day.day }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarMonthData from "./libraries/CalendarMonthData";
import Formatter from "@/components/libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "DatePicker",
  data() {
    return {
      show: false,
      nowDate: new Date(),
      calendar: [],
      nowMonthName: "",
      nowYear: ""
    };
  },
  props: {
    value: String, // выбранное значение по умолчанию. формат: дд.мм.гггг
    active: Array, // Массив активных дней. Если не заполняется, то все дни активные. Формат: 'yyyy-mm-dd'
    hideInput: Boolean, // Скрываем input для тех мест, где надо открывать календарь при клике на объект, а не форму
    formClickImitate: Number // Имитация клика на input для открытия календаря
  },
  watch: {
    formClickImitate: function(val){
      if(val > 0){
        this.showCalendar();
      }
    },
    value: function(val) {
      if (val !== "") {
        this.nowDate = formatter.rusDateToJSObject(val);
      }
    },
    active: function() {
      this.renderCalendar();
    }
  },
  computed: {
    activeComputed(){
      let result = [];

      if(this.active && this.active.length > 0){
        result = this.active;

        if(this.value !== ''){
          let valuePhp = formatter.jsObjectToPhp(formatter.rusDateToJSObject(this.value));
          let existsValue = false;
          for(let key in result){
            if(result[key] === valuePhp){
              existsValue = true;
            }
          }
          if(!existsValue){
            result[result.length] = valuePhp;
          }
        }

      }

      return result;
    },
    displayInputComputed(){
      if(this.hideInput === true){
        return 'none';
      }else{
        return 'inline-block';
      }
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    showCalendar() {
      this.show = true;
      if (this.model !== "") {
        this.nowDate = formatter.rusDateToJSObject(this.model);
      } else {
        this.nowDate = new Date();
      }
      this.renderCalendar();
    },
    renderCalendar() {
      let monthData = new CalendarMonthData(
        this.nowDate.getFullYear(),
        this.nowDate.getMonth()
      );
      let resultCalendar = monthData.getData();
      this.dateFrom = formatter.dateToPhpFormat(monthData.getDateFrom());
      this.dateTo = formatter.dateToPhpFormat(monthData.getDateTo());
      this.nowMonthName = monthData.getMonthName();
      this.nowYear = monthData.getYear();

      this.calendar = resultCalendar;
      for (let week in this.calendar) {
        for (let day in this.calendar[week]) {
          let activeFlag = false;
          if (this.activeComputed.length) {
            for (let active in this.activeComputed) {
              let activeDate = formatter.phpDateToJSObject(this.activeComputed[active]);
              let cycleDate = formatter.paramsDateToJSObject(
                this.calendar[week][day].day,
                this.calendar[week][day].month,
                this.calendar[week][day].year
              );
              if (activeDate.getTime() === cycleDate.getTime()) {
                activeFlag = true;
              }
            }
            this.$set(this.calendar[week][day], "active", activeFlag);
          } else {
            if(this.calendar[week][day].day){
              this.$set(this.calendar[week][day], "active", true);
            }else{
              this.$set(this.calendar[week][day], "active", false);
            }
          }
          if(!activeFlag){
            this.$set(this.calendar[week][day], "selected", false);
          }
        }
      }
      if (this.model !== "") {
        let modelDate = formatter.rusDateToJSObject(this.model);
        let phpModelDate = formatter.jsObjectToPhp(modelDate);

        let resetModel;
        if (modelDate.getMonth() !== this.nowDate.getMonth()) {
          resetModel = false;
        } else {
          resetModel = true;
        }
        for (let week in this.calendar) {
          for (let day in this.calendar[week]) {
            let dateCalendar = formatter.paramsDateToJSObject(
              this.calendar[week][day].day,
              this.calendar[week][day].month,
              this.calendar[week][day].year
            );
            // Если есть массив active, то учитываем это
            if (this.activeComputed.length) {
              if (
                modelDate.getTime() === dateCalendar.getTime() &&
                this.active.includes(phpModelDate)
              ) {
                resetModel = false;
                this.selectDay(this.calendar[week][day]);
              }
            } else {
              if (modelDate.getTime() === dateCalendar.getTime()) {
                resetModel = false;
                this.selectDay(this.calendar[week][day]);
              }
            }
          }
        }
        if (resetModel) {
          this.model = "";
        }
      }
    },
    selectDay(dayObj) {
      if (!dayObj.active) {
        return false;
      }
      let dateSelected = formatter.paramsDateToJSObject(
        dayObj.day,
        dayObj.month,
        dayObj.year
      );
      for (let week in this.calendar) {
        for (let day in this.calendar[week]) {
          let dateCalendar = formatter.paramsDateToJSObject(
            this.calendar[week][day].day,
            this.calendar[week][day].month,
            this.calendar[week][day].year
          );
          if (dateSelected.getTime() === dateCalendar.getTime()) {
            this.model = formatter.dateParamsToRus(
              this.calendar[week][day].day,
              +this.calendar[week][day].month + 1,
              this.calendar[week][day].year
            );
            this.$set(this.calendar[week][day], "selected", true);
          } else {
            this.$set(this.calendar[week][day], "selected", false);
          }
        }
      }
      return true;
    },
    clickSelectDay(dayObj) {
      let selectDayResult = this.selectDay(dayObj);
      if(selectDayResult){
        this.hideCalendar();
      }
    },
    hideCalendar() {
      this.show = false;
    },
    prevMonth() {
      this.nowDate.setDate(1);
      this.nowDate.setMonth(this.nowDate.getMonth() - 1);
      this.renderCalendar();
    },
    nextMonth() {
      this.nowDate.setDate(1);
      this.nowDate.setMonth(this.nowDate.getMonth() + 1);
      this.renderCalendar();
    }
  }
};
</script>

<style scoped lang="less">
.date-picker--container {
}
.date-picker--actions {
  padding: 8px 3px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  .month{
    width: 70%;
    text-align: center;
    font-size: 15px;
  }

  .left, .right{
    width: 15%;
    text-align: center;
    font-size: 18px;
    color: #f97979;
  }
}
.date-picker--back {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 19999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
.date-picker--calendar {
  position: absolute;
  z-index: 20000;
  width: 250px;
  height: auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 1px 5px 9px 1px rgba(0, 0, 0, 0.55);
}

.date-picker--calendar-body {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    display: inline-block;
    text-align: center;
    min-width: 25px;
    max-width: 35px;
    width: 360px;
    // border-bottom: 1px solid #c4c4c4;
    box-sizing: border-box;
    cursor: pointer;
  }
}
.date-picker--calendar-weeksname {
  & > div {
    height: 30px;
    color: #333333;
    font-size: 11px;
    line-height: 30px;
  }
  & > div.weekend {
    color: #f97979;
  }
}
.date-picker--calendar-week {
  & > div {
    padding: 6px 0;
  }

  .item {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;

    &.selected {
      background-color: #e2e2e2;
    }

    .date {
      width: 30%;
      font-size: 11px;
      color: #c4c4c4;
      font-weight: 700;

      .active {
        color: #333;
      }
      .today {
        display: inline-block;
        border-bottom: 2px solid #f97979;
      }
    }
  }
}
@media (max-width: 600px) {
  .date-picker--calendar {
    right: 0;
    left: 0;
    margin: auto;
  }
}
</style>
